import { Link } from "react-router-dom";
import { assetUrl } from "@/lib/assets";

/**
 * CEC brushmark — uses the official brand PNG (transparent navy brush-circle
 * with "CEC" wordmark and "CARLTON ELLEKER CHASE" subline). The image is
 * masked in via a radial reveal for a subtle ink-draw entrance.
 */
export default function BrushMark({
  size = 84,
  className = "",
  asLink = true,
}) {
  const inner = (
    <span
      className={`inline-flex items-center justify-center select-none ${className}`}
      style={{ width: size, height: size }}
      data-testid="cec-brushmark"
      aria-label="Carlton Elleker Chase"
    >
      <img
        src={assetUrl("/brand/cec-logo.png")}
        alt="Carlton Elleker Chase"
        className="brush-ink-in block w-full h-full object-contain"
        draggable={false}
      />
    </span>
  );
  if (!asLink) return inner;
  return (
    <Link to="/" data-testid="logo-link" aria-label="Carlton Elleker Chase home" className="inline-flex">
      {inner}
    </Link>
  );
}
